module.exports = __webpack_public_path__ + "img/03.e2e95c21.png";